/* Artist Collaboration Program, ported from ~/websites/artist-collaboration-program.
   The microsite's two scripts, verbatim apart from: state classes on .pf-acp instead
   of <body>, film pace + painting aspects read from the section, the post-layout
   anchor jump and image warm-up in reveal(), and the Apply form now posting natively
   to Shopify's contact form (sections/pf-artist-collaboration.liquid). */
(function(){
  'use strict';

  /* The page lives inside the theme now, so the state classes the microsite put
     on <body> (is-loading, in-film, past-film, has-cursor) go on its root. */
  var body = document.querySelector('.pf-acp');
  if (!body) return;

  var ART_W = 1291, ART_H = 968;
  var ART_ASPECT = ART_W / ART_H;

  /* Act I anchors, measured off assets/hero/hut.png as canvas fractions */
  var WIN  = { x0:0.3757, x1:0.5895, y0:0.4514, y1:0.6756 };
  var ROOF = { x:0.500, y:0.300, w:0.105 };   /* half size, sits on the tiles */
  var WALL = { x:0.500, y:0.413 };

  /* the canopy runs bigger than the hut and sits lower, so foliage reaches the
     top edge of the frame instead of showing wall behind it */
  var FG_BASE = 1.20, FG_DROP = 0.05;
  var SB   = { mark:[0.00,0.18], title:[0.21,0.38], story:[0.42,0.62] };
  var WIDE = 0.96;

  /* Acts II–IV run as one continuous studio timeline (studio-local t):
     0.04-0.34 carousel right to left · 0.34-0.42 sides clear
     0.34-0.44 the market canvas comes toward the screen
     0.44-0.56 a full turn — the stretched linen underside, then back to front
     0.52-0.60 the postcard rises behind it, its mount still empty
     0.58-0.70 the painting turns a quarter and is placed onto that mount
     0.72-0.80 the card folds · 0.82-0.89 a hand takes it
     0.90-0.95 the hand carries it right · 0.91-1.00 the programme sheet arrives */
  var ST = {
    ride:[0.04,0.30], title:[0.06,0.27], clear:[0.28,0.34], grow:[0.34,0.44],
    flip:[0.44,0.56], card:[0.52,0.60], place:[0.58,0.70],
    fold:[0.72,0.80], hand:[0.82,0.89], shift:[0.90,0.95], paper:[0.90,0.97]
  };

  /* The hang is the three paintings run twice. A single set wrapping over
     three slots leaves a hole on one side mid-ride; six slots means the
     wrap-around always happens off-screen. */
  var PAINTINGS = [
    { id:'cv0', aspect:798/570, tilt:-1.1 },
    { id:'cv1', aspect:712/568, tilt: 0.8 },
    { id:'cv2', aspect:816/583, tilt:-0.6 },   /* market — the one that flips */
    { id:'cv3', aspect:798/570, tilt: 1.0 },
    { id:'cv4', aspect:712/568, tilt:-0.9 },
    { id:'cv5', aspect:816/583, tilt: 0.7 }
  ];
  var FOCUS = 2;

  /* one dial for the whole film's pace — higher is slower. A phone screen is
     a third the height, so the same dial means three times the swipes: run
     it shorter on touch devices. */
  var coarse = window.matchMedia('(pointer:coarse)').matches;
  var SPEED = parseFloat(coarse ? body.dataset.paceMobile : body.dataset.paceDesktop) || (coarse ? 1.0 : 1.5);
  var SHOTS = [
    { kind:'scene',  w:6.40 * SPEED, fade:0.24 },
    { kind:'studio', w:12.20 * SPEED, fade:0.00 },
    /* same room, same wall — only the actors change, so there is no cut */
    { kind:'studio', act:'wheel', w:6.60 * SPEED, fade:0.00 },
    /* the paper grows out of the wheel and the programme is written on it */
    { kind:'studio', act:'page',  w:3.40 * SPEED, fade:0.00 }
  ];

  /* The wheel: a station per collectible. `h` is the item's height and `r`
     where its base is pinned, both in disc radii, measured off the supplied
     frames. The spacing between stations is NOT fixed — it is derived from the
     frame at run time, see driveWheel. */
  var COLLECTIBLES = [
    { id:'wi0', h:0.63, r:0.76, aspect:505/560, label:'Mini desk calendars' },
    { id:'wi1', h:0.82, r:0.64, aspect:1080/1080, label:'Bookmarks' },
    { id:'wi2', h:0.81, r:0.60, aspect:1080/1440, label:'Custom stamps' },
    { id:'wi3', h:0.44, r:0.93, aspect:600/440, label:'Fridge magnets' }   /* pinned higher still up the disc */
  ];

  /* Act VI's three written panels. Declared HERE, beside COLLECTIBLES, because
     the element-ref block below reaches for both — a var assigned further down
     is hoisted but still undefined at that point, which is a load-time crash,
     not a syntax error. */
  var PANELS = [
    { id:'pg0', at:[0.06, 0.38] },
    { id:'pg1', at:[0.38, 0.70] },
    { id:'pg2', at:[0.70, 1.00] }
  ];

  var CHAPTERS = [
    { num:'I',   name:'The Forest',      shot:0, at:0.00 },
    { num:'II',  name:'The Studio',      shot:1, at:0.05 },
    { num:'III', name:'The Canvas',      shot:1, at:0.43 },
    { num:'IV',  name:'The Postcard',    shot:1, at:0.70 },
    { num:'V',   name:'The Collectibles',shot:2, at:0.12 },
    { num:'VI',  name:'The Programme',   shot:3, at:0.06 }
  ];

  var film   = document.getElementById('film');
  var stage  = film.querySelector('.stage');
  var scene  = document.getElementById('scene');
  var typeEl = document.getElementById('type');
  var lyBg   = document.getElementById('lyBg');
  var lyHut  = document.getElementById('lyHut');
  var lyFg   = document.getElementById('lyFg');
  var hint   = document.getElementById('hint');
  var fill   = document.getElementById('progressFill');
  var nav    = document.getElementById('chapters');

  var markRoof   = document.getElementById('markRoof');
  var presentsEl = document.getElementById('presents');
  var titleWall  = document.getElementById('titleWall');
  var winWash    = document.getElementById('winWash');
  var storyWin   = document.getElementById('storyWin');
  var cornerMark = document.getElementById('cornerMark');

  var studio    = document.getElementById('studio');
  var stInner   = document.getElementById('stInner');
  var rail      = document.getElementById('rail');
  var stWall    = document.getElementById('stWall');
  var stPool    = document.getElementById('stPool');
  var studioTy  = document.getElementById('studioType');
  var arcTitle  = document.getElementById('arcTitle');
  var sheet     = document.getElementById('sheet');
  var pcard     = document.getElementById('pcard');
  var pcLeft    = document.getElementById('pcLeft');
  var hand      = document.getElementById('hand');
  var handPool  = document.getElementById('handPool');
  var wheel     = document.getElementById('wheel');
  var wheelDisc = document.getElementById('wheelDisc');
  var wheelLabel = document.getElementById('wheelLabel');
  var wheelPrimary = document.getElementById('wheelPrimary');
  var page      = document.getElementById('page');
  var pageVeil  = document.getElementById('pageVeil');
  var wheelFace = document.getElementById('wheelFace');
  COLLECTIBLES.forEach(function(c){ c.el = document.getElementById(c.id); });
  PANELS.forEach(function(p){ p.el = document.getElementById(p.id); });

  PAINTINGS.forEach(function(p){
    p.el = document.getElementById(p.id);
    p.aspect = parseFloat(p.el.getAttribute('data-aspect')) || p.aspect;   /* follows a swapped painting */
  });

  var reduce    = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var total = 0, i;
  for (i = 0; i < SHOTS.length; i++) total += SHOTS[i].w;
  var starts = [], acc = 0;
  for (i = 0; i < SHOTS.length; i++){ starts[i] = acc / total; acc += SHOTS[i].w; }
  starts[SHOTS.length] = 1;

  CHAPTERS.forEach(function(ch){
    ch.p = starts[ch.shot] + ch.at * (starts[ch.shot + 1] - starts[ch.shot]);
    var b = document.createElement('button');
    b.type = 'button';
    b.setAttribute('data-od-id', 'chapter-' + ch.name.toLowerCase().replace(/\s+/g,'-'));
    b.innerHTML = '<span class="num">' + ch.num + '</span><span class="name">' + ch.name + '</span>';
    b.addEventListener('click', function(){
      var filmTop = film.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({ top: Math.round(filmTop + (ch.p + 0.004) * scrollable()),
                        behavior: reduce ? 'auto' : 'smooth' });
    });
    nav.appendChild(b);
    ch.el = b;
  });

  var storyBox = { key:'', h:0 };
  var stageH = 0, sceneBase = 1.1, storyWidth = 0;
  function scrollable(){ return film.offsetHeight - stageH; }

  function measure(){
    stageH = stage.offsetHeight || window.innerHeight;
    var vw = stage.clientWidth || window.innerWidth;
    var containH = Math.min(stageH, vw / ART_ASPECT);
    sceneBase = Math.min(1.45, Math.max((stageH / containH) * 0.92, vw / (containH * ART_ASPECT)));
    /* Keep both text blocks at one width for the whole shot. The camera can
       move around them without making lines reflow as the user scrolls. */
    titleWall.style.width = Math.min(vw * 0.92, 1220).toFixed(1) + 'px';
    storyWidth = Math.min(vw * 0.86, 620);
    storyWin.style.width = storyWidth.toFixed(1) + 'px';
    storyBox.key = '';
    /* the rail keeps stage coordinates even though its parent overhangs by 44% */
    rail.style.top    = (0.44 * stageH).toFixed(1) + 'px';
    rail.style.height = stageH.toFixed(1) + 'px';
  }
  /* Lay the title out along a circular arc, symmetric about the centre. R is
     derived from the block width, so curvature stays proportional. */
  function buildArc(){
    var txt = arcTitle.getAttribute('data-text') || '';
    var spans = [], i, el;
    arcTitle.innerHTML = '';
    for (i = 0; i < txt.length; i++){
      el = document.createElement('i');
      el.textContent = txt.charAt(i) === ' ' ? ' ' : txt.charAt(i);
      arcTitle.appendChild(el);
      spans.push(el);
    }
    var w = [], sum = 0;
    for (i = 0; i < spans.length; i++){ w[i] = spans[i].offsetWidth; sum += w[i]; }
    if (!sum) return;
    var R = Math.max(1100, arcTitle.clientWidth * 2.7);
    arcTitle.style.setProperty('--arc-r', R.toFixed(0) + 'px');
    var acc = 0;
    for (i = 0; i < spans.length; i++){
      var cx = acc + w[i] / 2 - sum / 2;
      acc += w[i];
      spans[i].style.transform =
        'translateX(-50%) rotate(' + ((cx / R) * 180 / Math.PI).toFixed(3) + 'deg)';
    }
    var sag = R - Math.sqrt(Math.max(0, R * R - (sum / 2) * (sum / 2)));
    arcTitle.style.height = (spans[0].offsetHeight + sag + 8).toFixed(0) + 'px';
  }

  function layout(){
    measure();
    film.style.height = Math.round(stageH * (total + 1)) + 'px';
    buildArc();
  }

  function clamp(v){ return v < 0 ? 0 : v > 1 ? 1 : v; }
  function smooth(t){ return t * t * (3 - 2 * t); }
  function lerp(a, b, u){ return a + (b - a) * u; }
  function seg(q, a, b){ return clamp((q - a) / (b - a)); }
  function track(q, keys){
    if (q <= keys[0][0]) return keys[0][1];
    for (var i = 1; i < keys.length; i++){
      if (q <= keys[i][0]){
        var u = (q - keys[i-1][0]) / (keys[i][0] - keys[i-1][0]);
        return keys[i-1][1] + (keys[i][1] - keys[i-1][1]) * u;
      }
    }
    return keys[keys.length - 1][1];
  }

  /* ── Act I ─────────────────────────────────────────────────────────── */
  function artBox(){
    var sw = stage.clientWidth || window.innerWidth, sh = stageH;
    var k  = Math.min(sw / ART_W, sh / ART_H);
    var bw = ART_W * k, bh = ART_H * k;
    return { x:(sw - bw) / 2, y:(sh - bh) / 2, w:bw, h:bh, sw:sw, sh:sh };
  }
  function project(ax, ay, cam){
    var px = cam.box.x + ax * cam.box.w, py = cam.box.y + ay * cam.box.h;
    return { x: cam.cx + (px - cam.cx) * cam.s + cam.tx,
             y: cam.cy + (py - cam.cy) * cam.s + cam.ty };
  }
  function diveScale(box){
    var byH = 0.90 * box.sh / (box.h * (WIN.y1 - WIN.y0));
    var byW = 0.94 * box.sw / (box.w * (WIN.x1 - WIN.x0));
    if (box.sw < box.sh) byW *= 1.5;
    return Math.max(sceneBase * 2.2, Math.min(byH, byW));
  }

  function driveScene(q){
    var box  = artBox();
    var dive = diveScale(box);
    /* Wide is reached at 0.72, leaving the last 0.24 of the shot entirely to the
       arc transition — 2.3 screens of scroll instead of the previous 1.1. */
    var s = track(q, [[0, sceneBase], [0.20, sceneBase * 1.16], [0.34, sceneBase * 1.78],
                      [0.48, dive], [0.62, dive * 1.03], [0.72, WIDE], [1, WIDE * 0.985]]);
    var wgt = track(q, [[0,0], [0.20,0], [0.48,1], [0.62,1], [0.72,0], [1,0]]);
    var cx = box.sw / 2, cy = box.sh / 2;
    var wcx = box.x + ((WIN.x0 + WIN.x1) / 2) * box.w;
    var wcy = box.y + ((WIN.y0 + WIN.y1) / 2) * box.h;
    var tx = -(wcx - cx) * s * wgt, ty = -(wcy - cy) * s * wgt;

    lyHut.style.transform = 'translate(' + tx.toFixed(2) + 'px,' + ty.toFixed(2) + 'px) scale(' + s.toFixed(4) + ')';

    var reg  = smooth(seg(q, 0.60, 0.72));
    var fgIn = track(q, [[0, sceneBase], [0.34, sceneBase * 1.50], [0.46, sceneBase * 3.40],
                         [1, sceneBase * 3.40]]);
    var fgS  = (fgIn + (s - fgIn) * reg) * FG_BASE;
    var fgK  = 0.8 + 0.2 * reg;
    var fgY  = ty * fgK + box.sh * FG_DROP;
    lyFg.style.opacity = track(q, [[0,1], [0.30,1], [0.42,0], [0.60,0], [0.72,1], [1,1]]).toFixed(3);
    lyFg.style.transform = 'translate(' + (tx * fgK).toFixed(2) + 'px,' + fgY.toFixed(2) + 'px) scale(' + fgS.toFixed(4) + ')';

    lyBg.style.transform =
      'translateY(' + track(q, [[0,0], [0.48,-2], [0.72,0], [1,0]]).toFixed(2) + '%) scale(' +
      track(q, [[0,1], [0.48,1.26], [0.72,1], [1,1]]).toFixed(4) + ')';

    return { box:box, s:s, tx:tx, ty:ty, cx:cx, cy:cy };
  }

  function beatVal(q, win){
    if (q < win[0] || q > win[1]) return null;
    var u = (q - win[0]) / (win[1] - win[0]);
    if (u < 0.22){ var a = smooth(u / 0.22); return { o:a, y:lerp(14, 0, a) }; }
    if (u > 0.78){ var d = smooth((u - 0.78) / 0.22); return { o:1 - d, y:lerp(0, -12, d) }; }
    return { o:1, y:0 };
  }
  function put(el, x, y, dy){
    el.style.left = x.toFixed(1) + 'px';
    el.style.top  = y.toFixed(1) + 'px';
    el.style.transform = 'translate(-50%,-50%)' + (dy ? ' translateY(' + dy.toFixed(1) + 'px)' : '');
  }
  function hideType(){
    markRoof.style.opacity = '0'; presentsEl.style.opacity = '0';
    titleWall.style.opacity = '0'; storyWin.style.opacity = '0';
    winWash.style.opacity = '0'; cornerMark.style.opacity = '0';
  }

  function driveType(q, cam){
    if (!cam || q < 0){ hideType(); return; }
    var v, p;

    v = beatVal(q, SB.mark);
    if (v){
      var wmW = ROOF.w * cam.box.w * cam.s;
      markRoof.style.width = wmW.toFixed(1) + 'px';
      p = project(ROOF.x, ROOF.y, cam);
      put(markRoof, p.x, p.y, reduce ? 0 : v.y);
      markRoof.style.opacity = v.o.toFixed(3);

      p = project(ROOF.x, ROOF.y + 0.042, cam);
      put(presentsEl, p.x, p.y, reduce ? 0 : v.y);
      presentsEl.style.opacity = v.o.toFixed(3);
    } else { markRoof.style.opacity = '0'; presentsEl.style.opacity = '0'; }

    v = beatVal(q, SB.title);
    if (v){
      p = project(WALL.x, WALL.y, cam);
      put(titleWall, p.x, p.y, reduce ? 0 : v.y);
      titleWall.style.opacity = v.o.toFixed(3);
    } else titleWall.style.opacity = '0';

    v = beatVal(q, SB.story);
    if (v){
      var a = project(WIN.x0, WIN.y0, cam), b = project(WIN.x1, WIN.y1, cam);
      var winW = b.x - a.x, winH = b.y - a.y;
      var bw = storyWidth;
      var tx = a.x + winW * 0.635;
      var ty = a.y + winH * 0.36;   /* sits high in the opening, not centred */
      tx = Math.max(bw / 2 + 14, Math.min(cam.box.sw - bw / 2 - 14, tx));

      /* Hold the block inside the opening. Measured, not estimated — but keyed
         to a viewport width so it is not a layout read on every frame. */
      var key = Math.round(bw);
      if (key !== storyBox.key){ storyBox.key = key; storyBox.h = storyWin.offsetHeight; }
      var lo = a.y + storyBox.h / 2 + winH * 0.04;
      var hi = b.y - storyBox.h / 2 - winH * 0.04;
      /* on a phone the block can be taller than the opening — centre it there */
      ty = lo <= hi ? Math.max(lo, Math.min(hi, ty)) : (a.y + b.y) / 2;
      ty = Math.max(cam.box.sh * 0.16, Math.min(cam.box.sh * 0.84, ty));
      put(storyWin, tx, ty, reduce ? 0 : v.y);
      storyWin.style.opacity = v.o.toFixed(3);

      winWash.style.width  = (bw * 1.62).toFixed(1) + 'px';
      winWash.style.height = (bw * 1.20).toFixed(1) + 'px';
      put(winWash, tx, ty, 0);
      winWash.style.opacity = (v.o * 0.95).toFixed(3);
      cornerMark.style.opacity = (v.o * 0.9).toFixed(3);
    } else {
      storyWin.style.opacity = '0'; winWash.style.opacity = '0';
      cornerMark.style.opacity = '0';
    }
  }

  /* ── Acts II–IV ────────────────────────────────────────────────────── */
  function wrapD(d, n){
    var h = n / 2;
    return ((d % n) + n + h) % n - h;
  }

  function driveStudio(t){
    var sw = stage.clientWidth || window.innerWidth, sh = stageH;
    wheel.style.opacity = '0';   /* Act V only; driveWheel raises it after */
    page.style.opacity  = '0';   /* Act VI only */

    /* the hang rides right to left */
    var ride  = track(t, [[0, 0], [ST.ride[0], 0], [ST.ride[1], FOCUS], [1, FOCUS]]);
    var clear = smooth(seg(t, ST.clear[0], ST.clear[1]));
    var grow  = smooth(seg(t, ST.grow[0], ST.grow[1]));

    var baseH = Math.min(sh * 0.40, sw * 0.58, 420);
    var bigW  = Math.min(sw * 0.62, 900);

    /* Laid out on the inside of a cylinder: the wall bends toward the viewer at
       the edges, so the centre canvas is the farthest one and the arc spacing
       guarantees adjacent cutouts never overlap. R is derived from the widest
       canvas so the chord between neighbours always clears its width. */
    var DTH = 36 * Math.PI / 180;
    var R   = 1.30 * (baseH * 1.41) / DTH;

    /* The card's geometry is needed BEFORE the canvases are drawn: the market
       painting is not swapped for a card image, it lands on the card and then
       travels with it, so it has to run through the card's own transform. */
    var appear = smooth(seg(t, ST.card[0], ST.card[1]));
    var placed = smooth(seg(t, ST.place[0], ST.place[1]));
    var fold   = smooth(seg(t, ST.fold[0], ST.fold[1]));
    var toHand = smooth(seg(t, ST.hand[0], ST.hand[1]));
    var shift  = smooth(seg(t, ST.shift[0], ST.shift[1]));
    var shiftX = shift * sw * 0.22;   /* hand and card travel right together */

    var panelW = lerp(bigW / 2, Math.min(sw * 0.42, 420), toHand);
    var panelH = panelW * 1.424;   /* matches the reference postcard crop */

    /* The left panel swings behind the right one, so only the right half stays
       visible. That half sits at +panelW/2 inside the two-panel box, so the card
       must shift LEFT by half a panel to stay centred on screen. */
    var cDX = -fold * panelW / 2 + shiftX;
    var cDY = lerp(0, sh * 0.05, toHand);
    /* the fold's tilt unwinds again for the closing shot, so the card meets the
       hand square-on */
    var cRX = lerp(0, 4, fold) * (1 - toHand);
    var cRY = lerp(0, -12, fold) * (1 - toHand);
    /* The reference holds the print at this tilt and the hand plate was cut
       along that same edge, so the card has to settle at it for the grip to
       line up. Anything else opens a wedge between edge and fingers. */
    var cRZ = -8.5 * toHand;
    var CARD = ' translate3d(' + cDX.toFixed(1) + 'px,' + cDY.toFixed(1) + 'px,0)' +
               ' rotateX(' + cRX.toFixed(2) + 'deg) rotateY(' + cRY.toFixed(2) + 'deg)' +
               ' rotateZ(' + cRZ.toFixed(2) + 'deg)';

    /* a full turn — front, stretched linen underside, front again — finished
       before the placement starts, so the two rotations never fight */
    var flip = track(t, [[0,0], [ST.flip[0],0],
                         [(ST.flip[0] + ST.flip[1]) / 2, 180], [ST.flip[1],360], [1,360]]);
    /* the landed size: the cutout covers 93% of the mount's width, which leaves
       the white border the reference print has */
    var mountS = 0.93 * panelW / baseH;

    for (var i = 0; i < PAINTINGS.length; i++){
      var pn = PAINTINGS[i], el = pn.el;
      var d  = wrapD(i - ride, PAINTINGS.length);
      var w  = baseH * pn.aspect, h = baseH;
      var th = Math.max(-1.48, Math.min(1.48, d * DTH));
      var x  = R * Math.sin(th);
      var z  = Math.min(R * (1 - Math.cos(th)), 340);
      var ry = -d * 36, rz = pn.tilt, sc = 1, op, fx = 1;

      if (i === FOCUS){
        x  *= (1 - clear); z *= (1 - clear); ry *= (1 - clear); rz *= (1 - clear);
        sc  = 1 + grow * (bigW / w - 1);
        sc += placed * (mountS - sc);
        /* rides in front of the card while it rises, then settles onto its face */
        z  += 90 * appear * (1 - placed) + 2 * placed;
        x  += placed * panelW / 2;   /* the mount is the card's right half */
        ry += flip;
        rz += -90 * placed;          /* the quarter turn onto the mount */
        op  = 1;                     /* no swap — this element IS the print */
        /* mirrors as it lands on the mount: scaleX runs 1 -> -1 continuously
           over the same `placed` progress that drives the quarter turn, so it
           reads as part of the same physical settle rather than a hard swap. */
        fx  = 1 - 2 * placed;
        el.classList.toggle('cv--mounted', placed > 0.01);
      } else {
        /* fades only once it has actually left the frame, so the wrap-around
           at |d| = 3 is never visible */
        op = (1 - smooth(seg(Math.abs(d), 1.35, 1.85))) * (1 - clear);
      }

      el.style.width  = w.toFixed(1) + 'px';
      el.style.height = h.toFixed(1) + 'px';
      el.style.opacity = op.toFixed(3);
      el.style.filter = 'brightness(' + (1 - 0.45 * Math.min(1, Math.abs(d) / 1.15) * (1 - clear)).toFixed(3) + ')';
      el.style.transform =
        'translate(-50%,-50%)' + (i === FOCUS ? CARD : '') +
        ' translate3d(' + x.toFixed(1) + 'px,0,' + z.toFixed(1) + 'px)' +
        ' rotateY(' + ry.toFixed(2) + 'deg) rotateZ(' + rz.toFixed(2) + 'deg)' +
        ' scale(' + sc.toFixed(4) + ') scaleX(' + fx.toFixed(3) + ')';
    }

    /* The postcard rises with an empty mount, waits for the painting to be
       placed on it, then folds along its centre hinge and is offered up. */
    pcard.style.setProperty('--pcw', panelW.toFixed(1) + 'px');
    pcard.style.width   = (panelW * 2).toFixed(1) + 'px';
    pcard.style.height  = panelH.toFixed(1) + 'px';
    pcard.style.opacity = appear.toFixed(3);
    pcard.style.transform  = 'translate(-50%,-50%)' + CARD;
    pcLeft.style.transform = 'rotateY(' + (-fold * 180).toFixed(2) + 'deg)';

    /* wall drifts with the push, then eases back for the closing shot */
    stWall.style.transform = 'scale(' + track(t, [[0,1], [ST.grow[1],1.12], [ST.fold[1],1.04], [1,1]]).toFixed(4) + ')';
    stPool.style.opacity = (1 - clear * 0.35).toFixed(3);

    var tv = beatVal(t, ST.title);
    studioTy.style.opacity = tv ? tv.o.toFixed(3) : '0';
    /* CSS already carries `translate:-50% 0` for the centring. transform and
       translate COMPOSE, so adding translate(-50%,0) here as well threw the
       title a full panel-width off centre. Only the rise belongs here. */
    if (tv && !reduce) studioTy.style.transform = 'translateY(' + tv.y.toFixed(1) + 'px)';

    /* The plate is measured off the reference photograph. Three numbers carry
       it: the cut edge sits 27.1% across the plate, and that line must land on
       the card's right edge; the grip sits 42% down the card; and the hand
       spans 92% of the card's height. Height, not width — the reference print
       is nearly square and this card is a tall postcard, so scaling by width
       would leave a doll's hand on a full-height card.
       It is NOT inside the card's rotated frame: the card's tilt is already
       baked into the cut, and rotating it again would open a wedge.
       hand-v2.png is cropped tight to its own content (162×271); its
       thumb/finger grip-gap sits at the same ~27% fraction as the original
       plate, so the 0.229 grip offset below still holds — only the plate's
       own aspect ratio changed. */
    var cs = Math.cos(cRZ * Math.PI / 180), sn = Math.sin(cRZ * Math.PI / 180);
    var pcy = cDY + sn * panelW / 2;                 /* visible panel centre */
    var HH  = 0.92 * panelH, HW = HH * (162 / 271);
    var handX = cDX + cs * panelW + 0.229 * HW;      /* right edge + grip */
    var handY = pcy + 0.38 * panelH + (1 - toHand) * HH * 0.55;
    hand.style.width     = HW.toFixed(1) + 'px';
    hand.style.height    = HH.toFixed(1) + 'px';
    hand.style.opacity   = toHand.toFixed(3);
    hand.style.transform =
      'translate(-50%,-50%) translate3d(' + handX.toFixed(1) + 'px,' +
      handY.toFixed(1) + 'px,3px)' +
      ' rotateZ(' + ((1 - toHand) * 5).toFixed(2) + 'deg)';

    handPool.style.opacity   = (toHand * 0.85).toFixed(3);
    handPool.style.transform =
      'translate(-50%,-50%) translate3d(' + (cDX + panelW * 0.34).toFixed(1) + 'px,' +
      (cDY + panelH * 0.38).toFixed(1) + 'px,-2px)';

    /* the handmade sheet slides in from the left as the hand clears */
    var paperIn = smooth(seg(t, ST.paper[0], ST.paper[1]));
    sheet.style.opacity   = Math.min(1, paperIn * 4).toFixed(3);
    sheet.style.transform = 'translate(' + (-110 + 110 * paperIn).toFixed(2) + '%, -50%)';
  }

  /* ── Act V: the wheel ──────────────────────────────────────────────── */
  var ACTORS = null;
  function fadeActors(k){
    if (!ACTORS){
      ACTORS = [pcard, hand, handPool, sheet, studioTy];
      PAINTINGS.forEach(function(p){ ACTORS.push(p.el); });
    }
    /* Scaled one by one rather than by putting opacity on the rail: opacity is
       a grouping property, and flattening that 3D subtree would re-sort the
       card in front of the painting mounted on it. */
    for (var i = 0; i < ACTORS.length; i++){
      var el = ACTORS[i];
      el.style.opacity = ((parseFloat(el.style.opacity) || 0) * k).toFixed(3);
    }
  }

  /* The wheel's geometry — shared by Act V and Act VI, so the paper grows from
     exactly where it was turning. */
  function wheelGeom(sw, sh){
    /* Sized so the crown always clears the frame: scaled off the width, with a
       height floor so the wheel does not shrink away on a phone. */
    var R = Math.max(sw * 0.531, sh * 0.42);
    var apexY = sh * 0.568;                    /* where the crown sits, as in the frames */

    /* One cap and one floor. The cap: a piece is at its HIGHEST not at the
       crown and not at full swing, but at atan(halfWidth / reach) between
       them, where it reaches hypot(reach, halfWidth) radii — so that hypot,
       not the reach, is the number the frame has to hold if the piece at the
       crown is never to be beheaded. The floor keeps the disc running off the
       bottom edge. */
    var j, rise2 = 0;
    for (j = 0; j < COLLECTIBLES.length; j++){
      var c0 = COLLECTIBLES[j];
      rise2 = Math.max(rise2, Math.hypot(c0.r + c0.h, c0.h * c0.aspect / 2));
    }
    if (rise2 > 1) R = Math.min(R, (apexY - 14) / (rise2 - 1));
    R = Math.max(R, (sh - apexY) / 2 + 1);

    /* Stations a fifth of a turn apart. There is deliberately NO swing limit
       any more: a piece rides in from the bottom corner, up to the crown and
       away, and the frame clips it on the way in and out. That clipping is the
       point — it is what makes them arrive rather than materialise. Only the
       crown has to be fully inside the frame, which is what the cap above
       guarantees. */
    return { R:R, apexY:apexY, STEP:72 };
  }

  function driveWheel(t){
    var sw = stage.clientWidth || window.innerWidth, sh = stageH;

    /* The previous act is held on its last frame and dissolved out, so the
       hand-off happens inside one continuous room — same wall, same light. */
    driveStudio(1);
    fadeActors(1 - smooth(seg(t, 0.00, 0.12)));
    page.style.opacity = '0';                  /* Act VI only */

    var g = wheelGeom(sw, sh);
    var R = g.R, apexY = g.apexY, STEP = g.STEP;
    var rise = smooth(seg(t, 0.02, 0.18));
    var lift = (1 - rise) * sh * 0.30;         /* rolls up into frame */

    wheel.style.opacity = rise.toFixed(3);
    wheelFace.style.filter = 'none';   /* Act VI calms it; here it is full strength */
    wheelFace.classList.remove('is-shifting');
    pageVeil.style.opacity = '0';

    /* one turn per station, holding while each collectible is at the crown */
    var th = track(t, [[0, STEP * 0.55], [0.10, 0], [0.23, 0],
                       [0.36, -STEP], [0.49, -STEP],
                       [0.62, -2 * STEP], [0.75, -2 * STEP],
                       [0.88, -3 * STEP], [1, -3 * STEP]]);

    wheelDisc.style.width  = (2 * R).toFixed(1) + 'px';
    wheelDisc.style.height = (2 * R).toFixed(1) + 'px';
    wheelDisc.style.transform =
      'translate(-50%,' + (apexY + lift).toFixed(1) + 'px) rotate(' + th.toFixed(2) + 'deg)';

    var cy = apexY + R + lift;                 /* the disc's centre, in stage coords */
    for (var i = 0; i < COLLECTIBLES.length; i++){
      var c = COLLECTIBLES[i];
      var a = th + i * STEP, rad = a * Math.PI / 180;
      var h = c.h * R;
      var bx = c.r * R * Math.sin(rad);        /* where its base is pinned on the face */
      var by = cy - c.r * R * Math.cos(rad);
      c.el.style.width = (h * c.aspect).toFixed(1) + 'px';
      /* placed at the base point, spun with the wheel, seated on that point */
      c.el.style.transform =
        'translate(' + bx.toFixed(1) + 'px,' + by.toFixed(1) + 'px)' +
        ' rotate(' + a.toFixed(2) + 'deg) translate(-50%,-100%)';
      /* Opaque for the whole ride — it leaves by going off the frame, not by
         dissolving. The taper past 72deg only saves painting four large plates
         that are already well below the bottom edge. */
      c.el.style.opacity = (rise * (1 - smooth(seg(Math.abs(a), 72, 80)))).toFixed(3);
    }

    /* One caption, for whatever is at the crown. Two labels crossfading on the
       same spot would just be mush, so it dips out, swaps text, and comes back
       — the dip finishes before the halfway point between stations. */
    var near = 0, best = 1e9;
    for (i = 0; i < COLLECTIBLES.length; i++){
      var d = Math.abs(th + i * STEP);
      if (d < best){ best = d; near = i; }
    }
    if (wheelLabel.getAttribute('data-i') !== String(near)){
      wheelLabel.textContent = COLLECTIBLES[near].label || 'Name — awaiting copy';
      wheelLabel.classList.toggle('pending', !COLLECTIBLES[near].label);
      wheelLabel.setAttribute('data-i', String(near));
    }
    wheelLabel.style.opacity =
      (rise * (1 - smooth(seg(best, STEP * 0.20, STEP * 0.44)))).toFixed(3);
    /* the standing headline holds steady across all four stations — it
       doesn't crossfade with the per-item name, just rides in with the wheel */
    wheelPrimary.style.opacity = rise.toFixed(3);
  }

  /* ── Act VI: the paper takes the frame ─────────────────────────────── */
  function drivePage(t){
    var sw = stage.clientWidth || window.innerWidth, sh = stageH;

    /* the wheel is held on its last frame, then grows out of it. Growth used
       to run all the way to t=0.34 (2.5 screens at this shot's width) with
       the panels only starting once it finished — a long stretch of bare
       paper before any text appeared. A first pass moved that to 0.14, but
       "finish growing, THEN start text" is still a dead beat either way —
       text now starts at 0.07, overlapping the tail of the growth (which
       finishes at 0.10), so the paper is still visibly settling into place
       as the heading arrives instead of sitting there blank first. */
    driveWheel(1);
    var g = wheelGeom(sw, sh);
    var cover = smooth(seg(t, 0.02, 0.10));

    /* the pieces go first — they are pinned in stage coordinates, not to the
       disc, so they must not still be standing there while it grows */
    var gone = 1 - smooth(seg(t, 0.00, 0.13));
    for (var i = 0; i < COLLECTIBLES.length; i++){
      var el = COLLECTIBLES[i].el;
      el.style.opacity = ((parseFloat(el.style.opacity) || 0) * gone).toFixed(3);
    }
    wheelLabel.style.opacity = ((parseFloat(wheelLabel.style.opacity) || 0) * gone).toFixed(3);
    wheelPrimary.style.opacity = ((parseFloat(wheelPrimary.style.opacity) || 0) * gone).toFixed(3);

    /* Grown until the disc covers the frame corner to corner — its own radius
       against the half-diagonal, plus 10% for the deckle: its
       tightest radius is 0.954 of the disc box, so 4.8% is the bare minimum. */
    var need = Math.max(1, 1.10 * Math.hypot(sw / 2, sh / 2) / g.R);
    var sc = lerp(1, need, cover);
    var y  = lerp(g.apexY, sh / 2 - g.R, cover);
    /* picks up where Act V's last station left off, and keeps turning as it comes */
    var th = -3 * g.STEP + cover * 9;
    wheelDisc.style.transform =
      'translate(-50%,' + y.toFixed(1) + 'px) rotate(' + th.toFixed(2) + 'deg) scale(' + sc.toFixed(4) + ')';

    /* Quiet the sheet down as it arrives: the petals lose most of their colour
       and the wash settles over the middle, so the programme reads. Both are
       tied to `cover`, so the paper is at full character while it is still a
       wheel and only calms once it is a page. */
    wheelFace.style.filter =
      'saturate(' + lerp(1, 0.52, cover).toFixed(3) + ')' +
      ' brightness(' + lerp(1, 1.05, cover).toFixed(3) + ')' +
      ' contrast(' + lerp(1, 0.93, cover).toFixed(3) + ')';
    wheelFace.classList.toggle('is-shifting', cover > 0 && cover < 1);
    pageVeil.style.opacity = cover.toFixed(3);

    page.style.opacity = '1';
    for (i = 0; i < PANELS.length; i++){
      var p = PANELS[i], a = p.at[0], b = p.at[1];
      var inn = smooth(seg(t, a, a + 0.055));
      /* the last one holds to the end rather than fading into the sections */
      var outv = i === PANELS.length - 1 ? 0 : smooth(seg(t, b - 0.055, b));
      var o = inn * (1 - outv);
      p.el.style.opacity = o.toFixed(3);
      if (!reduce) p.el.style.transform =
        'translateY(' + (lerp(26, -26, smooth(seg(t, a, b)))).toFixed(1) + 'px)';
    }
  }

  /* ── render ────────────────────────────────────────────────────────── */
  var SURFACE = { scene:scene, studio:studio };
  var lastChapter = -1;

  /* wheel scrolling arrives in ~100px notches, so the raw position would
     step the film. Ease the progress toward the target each frame instead. */
  var pCur = -1, lastT = 0;
  function render(){
    var top = film.getBoundingClientRect().top;
    var pTarget = clamp(-top / scrollable());
    /* The ease is time-based, not per-frame: 12% of the gap per 60fps frame
       is a ~250ms settle, and it must stay ~250ms when frames are slow —
       per-frame easing on a slow machine left the film seconds behind the
       scroll, then catching up in a rush once the sticky section released. */
    var now = performance.now(), dt = Math.min(200, now - lastT); lastT = now;
    /* touch scrolling is already smooth, and easing on top of it makes the
       film visibly chase the finger for a second after every flick */
    if (pCur < 0 || reduce || coarse) pCur = pTarget;
    else pCur += (pTarget - pCur) * (1 - Math.pow(0.88, dt / 16.67));
    if (Math.abs(pTarget - pCur) < 0.00005) pCur = pTarget;
    else onScroll();
    var p = pCur;

    var inFilm = top <= 1 && -top <= scrollable() + stageH * 0.2;
    body.classList.toggle('in-film', inFilm && p < 0.999);
    body.classList.toggle('past-film', -top > scrollable() - stageH * 0.15);

    var s = SHOTS.length - 1;
    for (i = 0; i < SHOTS.length; i++){
      if (p < starts[i + 1]) { s = i; break; }
    }
    var shot = SHOTS[s];
    var span = starts[s + 1] - starts[s];
    var t    = span > 0 ? clamp((p - starts[s]) / span) : 0;
    var e    = shot.fade > 0 ? smooth(seg(t, 1 - shot.fade, 1)) : 0;
    var next = s + 1 < SHOTS.length ? SHOTS[s + 1] : null;

    for (var k in SURFACE){
      var on = (k === shot.kind) || (next && k === next.kind);
      var el = SURFACE[k];
      if (!on && el.style.visibility !== 'hidden'){
        el.style.visibility = 'hidden'; el.style.opacity = '0';
      } else if (on) el.style.visibility = 'visible';
    }

    if (shot.kind === 'scene'){
      scene.style.opacity = '1';
      /* the forest lifts away as the studio's arc rises under it */
      scene.style.transform = 'translateY(' + (-e * 24).toFixed(2) + '%)';
      typeEl.style.visibility = 'visible';
      driveType(t, driveScene(t));
    } else {
      typeEl.style.visibility = 'hidden';
      hideType();
    }

    if (shot.kind === 'studio'){
      studio.style.opacity = '1';
      stInner.style.transform = 'translateY(0%)';
      stInner.classList.add('at-rest');
      if (shot.act === 'page') drivePage(t);
      else if (shot.act === 'wheel') driveWheel(t);
      else driveStudio(t);
    } else if (next && next.kind === 'studio'){
      /* rises into frame behind its arched top edge, as in the reference */
      studio.style.opacity = '1';
      stInner.style.transform = 'translateY(' + ((1 - e) * 100).toFixed(2) + '%)';
      stInner.classList.remove('at-rest');
      driveStudio(0);
    }

    hint.style.opacity = p < 0.015 ? '1' : '0';
    fill.style.width = (p * 100).toFixed(2) + '%';

    var active = 0;
    for (i = 0; i < CHAPTERS.length; i++) if (CHAPTERS[i].p <= p + 1e-6) active = i;
    if (active !== lastChapter){
      for (i = 0; i < CHAPTERS.length; i++){
        CHAPTERS[i].el.setAttribute('aria-current', i === active ? 'true' : 'false');
      }
      lastChapter = active;
    }
  }

  var queued = false;
  function onScroll(){
    if (queued) return;
    queued = true;
    requestAnimationFrame(function(){ queued = false; render(); });
  }
  var lastW = window.innerWidth;
  function onResize(){
    if (Math.abs(window.innerWidth - lastW) < 1 &&
        Math.abs(stage.offsetHeight - stageH) < 120) return;
    lastW = window.innerWidth;
    layout(); render();
  }

  layout(); render();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onResize);

  /* ── physical cursor (19d adaptation) ────────────────────────────────
     Beige glowing fireflies that trail the pointer AND drift with scroll.
     Because the page is entirely scroll-driven, the cursor gently floats in
     the direction of scroll when no pointer movement is happening. */
  (function(){
    if (reduce || !matchMedia('(pointer:fine)').matches) return;
    var cursors = [...body.querySelectorAll('.cursor')].map(function(el, i){
      return { el:el, f:[0.72, 0.38, 0.20][i], x:window.innerWidth/2, y:window.innerHeight/2 };
    });
    var tx = window.innerWidth/2, ty = window.innerHeight/2, raf = null;
    var sy = 0;                      // scroll drift target (upward only)
    var lastScrollY = window.scrollY || window.pageYOffset;
    var scrollMomentum = 0;
    body.classList.add('has-cursor');

    function step(){
      var live = false;
      cursors.forEach(function(d, i){
        var jx = (Math.random() - 0.5) * 1.2;
        var jy = (Math.random() - 0.5) * 1.2;
        var dx = (tx + jx) - d.x;
        var dy = (ty + sy + jy) - d.y;
        d.x += dx * d.f;
        d.y += dy * d.f;
        if (Math.abs(dx) + Math.abs(dy) > 0.2) live = true;
        d.el.style.transform = 'translate(' + (d.x - d.el.offsetWidth/2).toFixed(1) + 'px,' +
                               (d.y - d.el.offsetHeight/2).toFixed(1) + 'px)';
      });
      sy *= 0.985;
      scrollMomentum *= 0.97;
      raf = live ? requestAnimationFrame(step) : null;
    }
    function go(){ if (!raf) raf = requestAnimationFrame(step); }

    window.addEventListener('pointermove', function(e){
      tx = e.clientX; ty = e.clientY;
      go();
    }, { passive: true });
    window.addEventListener('pointerdown', function(e){
      tx = e.clientX; ty = e.clientY;
      go();
    }, { passive: true });

    // scroll nudges the fireflies subtly upward only — no sideways drift
    window.addEventListener('scroll', function(){
      var y = window.scrollY || window.pageYOffset;
      var delta = y - lastScrollY;
      lastScrollY = y;
      if (!delta) return;
      scrollMomentum = Math.min(Math.abs(delta) * 0.16, 22);
      cursors.forEach(function(d, i){
        var strength = [1.0, 0.7, 0.4][i];
        sy -= scrollMomentum * strength * 0.28;
      });
      go();
    }, { passive: true });

    document.addEventListener('mouseleave', function(){
      cursors.forEach(function(d){ d.el.style.opacity = '0'; });
    });
    document.addEventListener('mouseenter', function(e){
      tx = e.clientX; ty = e.clientY;
      cursors.forEach(function(d){ d.x = tx; d.y = ty; d.el.style.opacity = '1'; });
      sy = 0;
      go();
    });
    go();
  })();

  var opening = [lyBg, lyHut, lyFg, markRoof].map(function(el){
    return el.decode ? el.decode().catch(function(){}) : Promise.resolve();
  });
  var done = false;
  function reveal(){
    if (done) return;
    done = true;
    body.classList.remove('is-loading');
    layout(); render();

    /* The film only gets its real height in layout(), so a #try / #apply link
       from elsewhere — or the contact form posting back — lands mid-film.
       Redo the jump now, instantly rather than smooth-scrolling the film. */
    var mark = body.querySelector('[data-jump]');
    var id = mark ? mark.getAttribute('data-jump') : location.hash.slice(1);
    var jump = id && document.getElementById(id);
    if (jump && body.contains(jump)){
      document.documentElement.style.scrollBehavior = 'auto';
      jump.scrollIntoView();
      document.documentElement.style.scrollBehavior = '';
    }
    var sent = body.querySelector('.apply-done');
    if (sent) sent.focus({ preventScroll: true });
    /* Decode every later act's pictures now, so none of them is decoded on the
       first frame it appears in. */
    body.querySelectorAll('img').forEach(function(img){
      if (img.decode) img.decode().catch(function(){});
    });
  }
  Promise.all(opening).then(reveal);
  setTimeout(reveal, 5000);
  window.addEventListener('load', function(){ layout(); render(); });
  /* Aboreto's metrics decide the arc spacing, so rebuild once it has loaded */
  if (document.fonts && document.fonts.ready){
    document.fonts.ready.then(function(){ storyBox.key = ''; buildArc(); render(); });
  }
})();

/* "Try it with your own art" — pure client-side preview. FileReader turns the
   upload into a data URL that never leaves the page; nothing is transmitted. */
(function(){
  var dz       = document.getElementById('tryDropzone');
  var input    = document.getElementById('tryFile');
  var fileName = document.getElementById('tryFileName');
  var bifold   = document.getElementById('previewBifold');
  var bifoldArt= document.getElementById('previewBifoldArt');
  var bookmark   = document.getElementById('previewBookmark');
  var bookmarkArt= document.getElementById('previewBookmarkArt');
  var clearBtn = document.getElementById('tryClear');
  var nameIn   = document.getElementById('tryName');
  var titleIn  = document.getElementById('tryTitle');
  var bfName   = document.getElementById('previewBifoldName');
  var bfTitle  = document.getElementById('previewBifoldTitle');
  var bfBio    = document.getElementById('previewBifoldBio');
  if (!dz || !input) return;

  function setBookmarkArt(url){
    if (bookmarkArt){
      bookmarkArt.style.backgroundImage = 'url(' + url + ')';
      bookmarkArt.style.backgroundSize = 'cover';
    }
    if (bookmark) bookmark.classList.add('has-art');
  }
  function clearBookmarkArt(){
    if (bookmarkArt){
      bookmarkArt.style.backgroundImage = '';
      bookmarkArt.style.backgroundSize = '';
    }
    if (bookmark) bookmark.classList.remove('has-art');
  }

  function detectOrientation(url, cb){
    var img = new Image();
    img.onload = function(){ cb(img.naturalWidth, img.naturalHeight); };
    img.onerror = function(){ cb(1, 1); };
    img.src = url;
  }
  function setArt(url, name){
    bifoldArt.style.backgroundImage = 'url(' + url + ')';
    detectOrientation(url, function(w, h){
      var isLandscape = w > h;
      bifold.classList.toggle('is-landscape', isLandscape);
      bifold.classList.toggle('is-portrait', !isLandscape);
      bifoldArt.style.transform = isLandscape ? 'rotate(90deg) scale(1.35)' : 'none';
      // fit the rotated image: it is wider than tall, so scale it so the short
      // side fills the flap without blowing past the long side.
      bifoldArt.style.backgroundSize = isLandscape ? 'auto 100%' : 'cover';
    });
    bifold.classList.add('has-art');
    setBookmarkArt(url);
    dz.classList.add('has-file');
    fileName.textContent = name;
  }
  function clearArt(){
    bifoldArt.style.backgroundImage = '';
    bifoldArt.style.transform = '';
    bifoldArt.style.backgroundSize = '';
    bifold.classList.remove('has-art','is-landscape','is-portrait');
    clearBookmarkArt();
    dz.classList.remove('has-file');
    input.value = '';
  }
  /* JPG or PNG up to 15 MB, as the hint says. Anything else (SVG, HEIC, a
     40 MB scan) is refused with a message instead of silently ignored. */
  var hint = document.getElementById('tryHint');
  var HINT = hint ? hint.textContent : '';
  function handleFile(file){
    if (!file) return;
    var ok = /^image\/(jpeg|png)$/.test(file.type) && file.size <= 15 * 1024 * 1024;
    if (hint) hint.textContent = ok ? HINT : 'Please choose a JPG or PNG under 15 MB.';
    if (!ok){ input.value = ''; return; }
    var reader = new FileReader();
    reader.onload = function(e){ setArt(e.target.result, file.name); };
    reader.readAsDataURL(file);
  }

  input.addEventListener('change', function(){ handleFile(input.files && input.files[0]); });
  ['dragover','dragenter'].forEach(function(ev){
    dz.addEventListener(ev, function(e){ e.preventDefault(); dz.classList.add('is-drag'); });
  });
  ['dragleave','drop'].forEach(function(ev){
    dz.addEventListener(ev, function(e){ e.preventDefault(); dz.classList.remove('is-drag'); });
  });
  dz.addEventListener('drop', function(e){
    handleFile(e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]);
  });
  if (clearBtn){
    clearBtn.addEventListener('click', function(e){
      e.preventDefault(); e.stopPropagation();
      clearArt();
    });
  }

  /* the bifold's left flap — name, title, and a fixed placeholder bio */
  function syncBifold(){
    var name = nameIn.value.trim();
    var title = titleIn.value.trim();
    if (bfName) bfName.textContent = name || 'Artist';
    if (bfTitle) bfTitle.textContent = (title || 'Untitled');
    if (bfBio) bfBio.textContent = name
      ? ('A short description of ' + name + ' will appear here so people get to know the artist behind the work.')
      : 'A short description of yourself will appear here so people get to know the artist behind the work.';
  }
  if (nameIn)  nameIn.addEventListener('input', syncBifold);
  if (titleIn) titleIn.addEventListener('input', syncBifold);

})();
